import protobuf from "protobufjs";
import environment from "src/utils/environment";

const { publicPath } = environment;

function createProtoRootPromise(path) {
  return new Promise((resolve) => {
    protobuf.load(publicPath + path, (err, root) => {
      if (err || !root) {
        // eslint-disable-next-line no-console
        console.log(`No ProtoRoot with path ${path}`, err);
        resolve(null);
        return;
      }
      resolve(root);
    });
  });
}

export default async function setupProtoRoots() {
  const communicationRoot = createProtoRootPromise(
    "/modules/communication-protobuf/communication.proto"
  );

  const babyCustomizationRoot = createProtoRootPromise(
    "/modules/babyCustomization-protobuf/babyCustomization.proto"
  );

  const dogCustomizationRoot = createProtoRootPromise(
    "/modules/dogCustomization-protobuf/dogCustomization.proto"
  );

  const mediaUploadRoot = createProtoRootPromise(
    "/modules/media-upload-protobuf/media-upload.proto"
  );

  const pushNotificationRoot = createProtoRootPromise(
    "/modules/push-notification-protobuf/push-notification.proto"
  );

  const deviceStatsRoot = createProtoRootPromise(
    "/modules/deviceStats-protobuf/deviceStats.proto"
  );

  const promises = [
    communicationRoot,
    babyCustomizationRoot,
    dogCustomizationRoot,
    mediaUploadRoot,
    pushNotificationRoot,
    deviceStatsRoot
  ];

  const roots = await Promise.all(promises);

  window.communicationRoot = roots[0];
  window.babyCustomizationRoot = roots[1];
  window.dogCustomizationRoot = roots[2];
  window.mediaUploadRoot = roots[3];
  window.pushNotificationRoot = roots[4];
  window.deviceStatsRoot = roots[5];
}
